/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaCalendarNav/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import BackAction from './BackAction/index'
import NextAction from './NextAction/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function TysiaCalendarNav({
  children,
  viewPath = "/DesignSystem/TysiaCalendarBlocks/TysiaCalendarNav",
  onClickPrevMonth,
  text = "May 2019",
  onClickNextMonth
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtTypographyFontsizeL = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.fontSize.l'
        })
  return (<React.Fragment
>
<div
  data-testid="TysiaCalendarNav.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-Sez1b': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--mb-2-Sez1b': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<BackAction
  viewPath={`${viewPath}/BackAction`}
 onClick={onClickPrevMonth}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text={text}
 fontSize={dtTypographyFontsizeL}
/>
<NextAction
  viewPath={`${viewPath}/NextAction`}
 onClick={onClickNextMonth}
/>
</div>
{children}
</React.Fragment>)
}